import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SUBSCRIPTIONS_SAGA } from "../sagaTypes";
import { loaderAction, subscriptionsAction, allSubscriptionsCountAction, paginationAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_subscriptions`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetSubscriptions(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const subscriptions_active_only = yield select(state => state.subscriptions_active_only);
    const subscriptions_inactive_only = yield select(state => state.subscriptions_inactive_only);
    const sort = yield select(state => state.sort);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('date', args.data?.date || '');
        formData.append('active_only', subscriptions_active_only);
        formData.append('inactive_only', subscriptions_inactive_only);
        formData.append('sort_field', sort.table === 'subscription' ? sort.field : '');
        formData.append('sort_order', sort.table === 'subscription' ? sort.order : '');
        formData.append('page', args.data?.page || 1);
        formData.append('search', args.data?.search || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(subscriptionsAction(response.subscriptions));
            yield put(paginationAction(response.pagination));
            yield put(allSubscriptionsCountAction(response.all_subscriptions_count));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetSubscriptions() {
    yield takeLatest(GET_SUBSCRIPTIONS_SAGA, workerGetSubscriptions);
}